import produce from 'immer'
import { Reducer } from 'redux'

import { QASection, QASectionNode } from 'interfaces/qa'
import {
  SET_QA_SECTION_ID,
  SET_QA_SECTIONS,
  SET_QA_SECTIONS_MAP,
  SET_QA_ROOT_SECTIONS,
  SET_QA_PICKED_SECTION,
  SET_QA_NODE_MAP,
  SET_QA_KEYWORD,
  SET_QA_SHOW_FAVOURITES_ONLY,
  SET_MOUSEABILITY_REFERENCE
} from 'redux/actions/types'
import { Flavour } from 'types/Flavour'
import { QA_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'

interface QAState {
  sectionId: string | null
  sections: Record<Flavour, QASectionNode> | null
  sectionsMap: Map<string, QASection> | null
  rootSections: QASection[] | null
  pickedSection: QASectionNode | null
  nodeMap: Map<string, QASection> | null
  keyword?: string
  showFavouritesOnly?: boolean
  mouseabilityReference?: string
}

const initialShowFavouritesOnly: boolean = JSON.parse(localStorage.getItem(QA_FAVOURITES_ONLY_KEY) ?? 'false')

const initialState: QAState = {
  sectionId: null,
  sections: null,
  sectionsMap: null,
  rootSections: null,
  pickedSection: null,
  nodeMap: null,
  keyword: '',
  showFavouritesOnly: initialShowFavouritesOnly
}

const qa: Reducer<QAState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_MOUSEABILITY_REFERENCE:
      return produce(state, draft => {
        draft.mouseabilityReference = action.mouseabilityReference
      })
    case SET_QA_SHOW_FAVOURITES_ONLY:
      return produce(state, draft => {
        draft.showFavouritesOnly = action.showFavouritesOnly
      })
    case SET_QA_SECTION_ID:
      return produce(state, draft => {
        draft.sectionId = action.sectionId
      })
    case SET_QA_SECTIONS:
      return produce(state, draft => {
        draft.sections = action.sections
      })
    case SET_QA_SECTIONS_MAP:
      return produce(state, draft => {
        draft.sectionsMap = action.sectionsMap
      })
    case SET_QA_ROOT_SECTIONS:
      return produce(state, draft => {
        draft.rootSections = action.rootSections
      })
    case SET_QA_PICKED_SECTION:
      return produce(state, draft => {
        draft.pickedSection = action.pickedSection
      })
    case SET_QA_NODE_MAP:
      return produce(state, draft => {
        draft.nodeMap = action.nodeMap
      })
    case SET_QA_KEYWORD:
      return produce(state, draft => {
        draft.keyword = action.keyword
      })
    default:
      return state
  }
}

export default qa
